import { RSAA, getJSON } from "redux-api-middleware";

import { EVENTMGT_SERVER } from "../../constants/constants";
import { initialSearchFilter as projectmailFilter } from "../../reducers/projectmail";

export const PROJECTMAIL_GET_TICKETSREQUEST = "PROJECTMAIL_GET_TICKETSREQUEST";
export const PROJECTMAIL_GET_TICKETSSUCCESS = "PROJECTMAIL_GET_TICKETSSUCCESS";
export const PROJECTMAIL_GET_TICKETSFAILURE = "PROJECTMAIL_GET_TICKETSFAILURE";

export const PROJECTMAIL_SET_EDITING_ON_TICKET_REQUEST = "PROJECTMAIL_SET_EDITING_ON_TICKET_REQUEST";
export const PROJECTMAIL_SET_EDITING_ON_TICKET_SUCCES = "PROJECTMAIL_SET_EDITING_ON_TICKET_SUCCES";
export const PROJECTMAIL_SET_EDITING_ON_TICKET_FAILURE = "PROJECTMAIL_SET_EDITING_ON_TICKET_FAILURE";

export const PROJECTMAIL_GET_TICKETS_ON_EDIT_REQUEST = "PROJECTMAIL_GET_TICKETS_ON_EDIT_REQUEST";
export const PROJECTMAIL_GET_TICKETS_ON_EDIT_SUCCESS = "PROJECTMAIL_GET_TICKETS_ON_EDIT_SUCCESS";
export const PROJECTMAIL_GET_TICKETS_ON_EDIT_FAILURE = "PROJECTMAIL_GET_TICKETS_ON_EDIT_FAILURE";

export const PROJECTMAIL_CHANGE_TAG_REQUEST = "PROJECTMAIL_CHANGE_TAG_REQUEST";
export const PROJECTMAIL_CHANGE_TAG_SUCCESS = "PROJECTMAIL_CHANGE_TAG_SUCCESS";
export const PROJECTMAIL_CHANGE_TAG_FAILURE = "PROJECTMAIL_CHANGE_TAG_FAILURE";

export const PROJECTMAIL_SET_FILTER = "PROJECTMAIL_SET_FILTER";
export const PROJECTMAIL_RESET_FILTER = "PROJECTMAIL_RESET_FILTER";

export const PROJECTMAIL_GET_TAGSREQUEST = "PROJECTMAIL_GET_TAGSREQUEST";
export const PROJECTMAIL_GET_TAGSSUCCESS = "PROJECTMAIL_GET_TAGSSUCCESS";
export const PROJECTMAIL_GET_TAGSFAILURE = "PROJECTMAIL_GET_TAGSFAILURE";

export const PROJECTMAIL_GET_TICKETS_SUM_REQUEST = "PROJECTMAIL_GET_TICKETS_SUM_REQUEST";
export const PROJECTMAIL_GET_TICKET_SUM_SSUCCESS = "PROJECTMAIL_GET_TICKET_SUM_SSUCCESS";
export const PROJECTMAIL_GET_TICKETS_SUM_FAILURE = "PROJECTMAIL_GET_TICKETS_SUM_FAILURE";

export const PROJECTMAIL_GET_EMAIL_REQUEST = "PROJECTMAIL_GET_EMAIL_REQUEST";
export const PROJECTMAIL_GET_EMAIL_SUCCESS = "PROJECTMAIL_GET_EMAIL_SUCCESS";
export const PROJECTMAIL_GET_EMAIL_FAILURE = "PROJECTMAIL_GET_EMAIL_FAILURE";

export const PROJECTMAIL_CLOSE_TICKET_REQUEST = "PROJECTMAIL_CLOSE_TICKET_REQUEST";
export const PROJECTMAIL_CLOSE_TICKET_SUCCESS = "PROJECTMAIL_CLOSE_TICKET_SUCCESS";
export const PROJECTMAIL_CLOSE_TICKET_FAILURE = "PROJECTMAIL_CLOSE_TICKET_FAILURE";

export const PROJECTMAIL_SET_COLORMAP = "PROJECTMAIL_SET_COLORMAP";
export const PROJECTMAIL_CHANGE_CURRENT_TYPE = "PROJECTMAIL_CHANGE_CURRENT_TYPE";
export const PROJECTMAIL_SET_LASTWORKEDTICKET = "PROJECTMAIL_SET_LASTWORKEDTICKET";
export const PROJECTMAIL_PUSH_TICKET_TO_HISTORY = "PROJECTMAIL_PUSH_TICKET_TO_HISTORY";
export const PROJECTMAIL_SET_TABLELAYOUT = "PROJECTMAIL_SET_TABLELAYOUT";
export const PROJECTMAIL_SET_CURRENTROW = "PROJECTMAIL_SET_CURRENTROW";
export const PROJECTMAIL_ACTIVATE_BELL_FOR_TICKTTYPE = "PROJECTMAIL_ACTIVATE_BELL_FOR_TICKTTYPE";
export const PROJECTMAIL_DEACTIVATE_BELL_FOR_TICKTTYPE = "PROJECTMAIL_DEACTIVATE_BELL_FOR_TICKTTYPE";
export const PROJECTMAIL_WS_CALL_TICKETUPDATE = "PROJECTMAIL_WS_CALL_TICKETUPDATE";
export const PROJECTMAIL_WS_CALL_NEW_TICKET = "PROJECTMAIL_WS_CALL_NEW_TICKET";
export const PROJECTMAIL_SET_ROW_AMOUNT = "PROJECTMAIL_SET_ROW_AMOUNT";
export const PROJECTMAIL_WEBSOCKETERROR_RELOAD = "PROJECTMAIL_WEBSOCKETERROR_RELOAD";
export const PROJECTMAIL_TOGGLE_TAGMODAL = "PROJECTMAIL_TOGGLE_TAGMODAL";
export const PROJECTMAIL_TOGGLE_INFOMODAL = "PROJECTMAIL_TOGGLE_INFOMODAL";
export const PROJECTMAIL_TOGGLE_EMAILMODAL = "PROJECTMAIL_TOGGLE_EMAILMODAL";

export const PROJECTMAIL_REQUEST_SET_ORDERID = "PROJECTMAIL_REQUEST_SET_ORDERID";
export const PROJECTMAIL_SUCCESS_SET_ORDERID = "PROJECTMAIL_SUCCESS_SET_ORDERID";
export const PROJECTMAIL_FAILURE_SET_ORDERID = "PROJECTMAIL_FAILURE_SET_ORDERID";

const successPayload = (action, state, res) => {
  return getJSON(res).then(json => json);
};

export const toggleTagModal = open => ({
  type: PROJECTMAIL_TOGGLE_TAGMODAL,
  open,
});

export const toggleEmailModal = open => ({
  type: PROJECTMAIL_TOGGLE_EMAILMODAL,
  open,
});

export const toggleInfoModal = open => ({
  type: PROJECTMAIL_TOGGLE_INFOMODAL,
  open,
});

export const websocketErrorReload = () => ({
  type: PROJECTMAIL_WEBSOCKETERROR_RELOAD,
});

export const closeTicket = id => ({
  [RSAA]: {
    endpoint: `${EVENTMGT_SERVER}/event-zammad/v1/tickets/closeTickets/${id}`,
    method: "POST",
    types: [PROJECTMAIL_CLOSE_TICKET_REQUEST, PROJECTMAIL_CLOSE_TICKET_SUCCESS, PROJECTMAIL_CLOSE_TICKET_FAILURE],
  },
});

export const setOrderId = (orderId, ticketId) => ({
  [RSAA]: {
    endpoint: `${EVENTMGT_SERVER}/event-zammad/v1/tickets/setOrderId/${ticketId}/orderId/${orderId}`,
    method: "POST",
    types: [PROJECTMAIL_REQUEST_SET_ORDERID, PROJECTMAIL_SUCCESS_SET_ORDERID, PROJECTMAIL_FAILURE_SET_ORDERID],
  },
});

export const getEmailFromId = id => {
  return {
    [RSAA]: {
      endpoint: `${EVENTMGT_SERVER}/event-zammad/v1/tickets/getTicketArticle/${id}`,
      method: "GET",
      types: [
        PROJECTMAIL_GET_EMAIL_REQUEST,
        {
          type: PROJECTMAIL_GET_EMAIL_SUCCESS,
          payload: async (action, state, res) => {
            const article = await res.json().then(re => re);
            return article;
          },
        },
        PROJECTMAIL_GET_EMAIL_FAILURE,
      ],
    },
  };
};

export const setLastWorkedTicket = lastWorkedTicket => ({
  type: PROJECTMAIL_SET_LASTWORKEDTICKET,
  lastWorkedTicket,
});

export const setEditingOnTicket = (id, onEdit) => ({
  [RSAA]: {
    endpoint: `${EVENTMGT_SERVER}/event-zammad/v1/tickets/editTickets/${id}?onEdit=${onEdit}`,
    method: "POST",
    types: [
      PROJECTMAIL_SET_EDITING_ON_TICKET_REQUEST,
      PROJECTMAIL_SET_EDITING_ON_TICKET_SUCCES,
      PROJECTMAIL_SET_EDITING_ON_TICKET_FAILURE,
    ],
  },
});

const mapQueryFilter = filter => {
  let a = "";
  Object.keys(filter).forEach(key => {
    if (filter[key] !== projectmailFilter[key]) a += `&${key}=${String(filter[key]).toLowerCase()}`;
  });
  return a;
};

export const getSearchedTickets = (filter, type, page) => ({
  [RSAA]: {
    endpoint: `${EVENTMGT_SERVER}/event-zammad/v1/tickets/getTicketsWithFilter?type=${type}${mapQueryFilter(filter)}${
      page ? "&page=" + page : ""
    }`,
    method: "GET",
    types: [
      PROJECTMAIL_GET_TICKETSREQUEST,
      {
        type: PROJECTMAIL_GET_TICKETSSUCCESS,
        payload: async (action, state, res) => ({ [type]: await successPayload(action, state, res) }),
      },
      PROJECTMAIL_GET_TICKETSFAILURE,
    ],
  },
});

export const getSearchedTicketsSum = () => ({
  [RSAA]: {
    endpoint: `${EVENTMGT_SERVER}/event-zammad/v1/tickets/getTicketCountForUser`,
    method: "GET",
    types: [
      PROJECTMAIL_GET_TICKETS_SUM_REQUEST,
      {
        type: PROJECTMAIL_GET_TICKET_SUM_SSUCCESS,
        payload: successPayload,
      },
      PROJECTMAIL_GET_TICKETS_SUM_FAILURE,
    ],
  },
});

export const getAvailableTags = () => ({
  [RSAA]: {
    endpoint: `${EVENTMGT_SERVER}/event-zammad/v1/tickets/getAvailableTags`,
    method: "GET",
    types: [
      PROJECTMAIL_GET_TAGSREQUEST,
      {
        type: PROJECTMAIL_GET_TAGSSUCCESS,
        payload: successPayload,
      },
      PROJECTMAIL_GET_TAGSFAILURE,
    ],
  },
});

export const setFilter = (filter, ticketType) => ({
  type: PROJECTMAIL_SET_FILTER,
  filter,
  ticketType,
});

export const resetFilter = ticketType => ({
  type: PROJECTMAIL_RESET_FILTER,
  ticketType,
});

export const changeTicketTags = (id, tags, del) => ({
  [RSAA]: {
    headers: { "Content-Type": "application/json" },
    endpoint: `${EVENTMGT_SERVER}/event-zammad/v1/tickets/editTags/${id}?delete=${del}`,
    method: "POST",
    body: JSON.stringify({ tags: tags.map(tag => `${tag}`) }),
    types: [PROJECTMAIL_CHANGE_TAG_REQUEST, PROJECTMAIL_CHANGE_TAG_SUCCESS, PROJECTMAIL_CHANGE_TAG_FAILURE],
  },
});

export const setColorMap = colorMap => ({
  type: PROJECTMAIL_SET_COLORMAP,
  colorMap,
});

export const setCurrentType = currentType => ({
  type: PROJECTMAIL_CHANGE_CURRENT_TYPE,
  currentType,
});

export const pushTicketToHistory = ticket => ({
  type: PROJECTMAIL_PUSH_TICKET_TO_HISTORY,
  ticket,
});

export const setTableLayout = (tableLayout, ticketType) => ({
  type: PROJECTMAIL_SET_TABLELAYOUT,
  tableLayout,
  ticketType,
});

export const setCurrentRow = row => ({
  type: PROJECTMAIL_SET_CURRENTROW,
  row,
});

export const activateBell = ticketType => ({
  type: PROJECTMAIL_ACTIVATE_BELL_FOR_TICKTTYPE,
  ticketType,
});

export const deactivateBell = ticketType => ({
  type: PROJECTMAIL_DEACTIVATE_BELL_FOR_TICKTTYPE,
  ticketType,
});

export const wsCallTicketUpdate = (ticketObject, username) => ({
  type: PROJECTMAIL_WS_CALL_TICKETUPDATE,
  ticketObject,
  username,
});

export const wsCallTicketNewTicket = (ticketObject, username) => ({
  type: PROJECTMAIL_WS_CALL_NEW_TICKET,
  ticketObject,
  username,
});

export const setRowAmount = rowAmount => ({
  type: PROJECTMAIL_SET_ROW_AMOUNT,
  rowAmount,
});
